module.exports = __webpack_public_path__ + "img/climbing.f131b5e6.jpg";